// Editor.js
import ReactQuill, { Quill } from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import classes from './Editor.module.scss'

// Embed ブロットをインポートしてカスタム VideoBlot を作成
const Embed = Quill.import('blots/block/embed')

class VideoBlot extends Embed {
  static create(url) {
    const node = super.create()
    node.setAttribute('src', url)
    node.setAttribute('frameborder', '0')
    node.setAttribute('allowfullscreen', true)
    node.setAttribute('width', '100%') // 幅を調整
    node.setAttribute('height', '400') // 高さを調整
    return node
  }

  static value(node) {
    return node.getAttribute('src')
  }
}

VideoBlot.blotName = 'video'
VideoBlot.tagName = 'iframe'
VideoBlot.className = 'ql-video'

// カスタム VideoBlot を Quill に登録
Quill.register(VideoBlot)

// ツールバーオプションを定義
const toolbarOptions = [
  [{ header: [1, 2, false] }],
  [{ font: [] }],
  [{ size: ['small', false, 'large', 'huge'] }],
  ['bold', 'italic', 'underline'],
  [{ color: [] }, { background: [] }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['link', 'image', 'video'], // "video" を追加
  ['clean'],
]

const Editor = (props) => {
  const { content, setContent } = props

  return (
    <ReactQuill
      value={content}
      onChange={setContent}
      modules={{ toolbar: toolbarOptions }}
      formats={[
        'header',
        'font',
        'size',
        'bold',
        'italic',
        'underline',
        'list',
        'bullet',
        'link',
        'image',
        'video', // "video" を追加
        'color',
        'background',
      ]}
    />
  )
}

export default Editor
